import styled from 'styled-components';

export const ImagePreviewWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height:40px;
    padding: 10px 5px; 
    img {
        width: auto;
        max-height: 40px;
        min-height: 40px;
        object-fit: cover;
    }
`;
